import { useTranslation as useOriginalTranslation } from 'react-i18next';
import { useEffect } from 'react';
import i18n from '../i18n';

/**
 * Custom hook that provides an untyped translation function
 * This is a workaround for TypeScript errors with i18next
 */
export function useUntypedTranslation() {
  // Force TypeScript to treat the result as any type
  // to completely bypass type checking
  const result = useOriginalTranslation('common') as any;

  // Normalize the language to one of our supported languages
  const normalizeLanguage = (lang: string): string => {
    // If language includes a region (e.g., 'en-US'), extract the main language part
    const mainLang = lang.split('-')[0];
    // Check if the main language is supported, otherwise default to 'en'
    return ['en', 'de'].includes(mainLang) ? mainLang : 'en';
  };

  // Effect to ensure language is normalized on mount
  useEffect(() => {
    const normalizedLang = normalizeLanguage(i18n.language);
    if (normalizedLang !== i18n.language) {
      i18n.changeLanguage(normalizedLang);
    }
  }, []);

  return result;
}
